import styles from "./loading.module.scss";

interface ISpinner {
  position?: "fixed" | "absolute" | "relative";
  backgroundColor?: string;
  zIndex?: number;
  positionValue?: {
    top?: number | string;
    left?: number | string;
    right?: number | string;
    bottom?: number | string;
  };
  height?: number | string;
}

/**
 * 로딩 스피너
 */
const LoadingSpinner = ({
  position = "fixed",
  backgroundColor = "rgba(255, 255, 255, 0.9)",
  zIndex = 200,
  positionValue = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  height = "100%",
}: ISpinner) => {
  return (
    <>
      <div
        className={styles["loading-spinner"]}
        style={{
          position: `${position}`,
          backgroundColor: `${backgroundColor}`,
          zIndex: `${zIndex}`,
          top: positionValue.top,
          left: positionValue.left,
          right: positionValue.right,
          bottom: positionValue.bottom,
          height: height,
        }}
      >
        <div className={styles["spinner"]}>
          <span></span>
        </div>
      </div>
    </>
  );
};

export default LoadingSpinner;
